import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import styles from "./Invite.module.css";
import InviteDialog from "./InviteDialog";
import EditInviteDialog from "./EditInviteDialog";
import DynamicDialog from "../../store/DynamicDialog/DynamicDialog.tsx";

const Invite = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [superAdmin, setSuperAdmin] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadingId, setLoadingId] = useState(null);
  const [trigger, setTrigger] = useState(false);
  const [showInviteDialog, setShowInviteDialog] = useState(false);
  const [showEditInviteDialog, setShowEditInviteDialog] = useState(false);
  const [showRemoveDialog, setShowRemoveDialog] = useState(false);
  const [editInfo, setEditInfo] = useState({
    email: "",
    role: "",
    option: "",
  });
  const [postLoader, setPostLoader] = useState(false);
  const [removeInfo, setRemoveInfo] = useState({
    email: "",
    tag: "",
  });
  useEffect(() => {
    async function fetchContactData() {
      try {
        fetch(`${process.env.REACT_APP_SERVER_URL}/all_admins`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          credentials: "include",
          method: "GET",
        })
          .then((response) => {
            if (response.status === 200) {
              return response.json();
            } else if (response.status === 202) {
              setIsLoaded(true);
              console.log("token expired");
              navigate("/login", { state: { sessionExpired: true } });
              return;
            } else {
              setIsLoaded(true);
              console.log("some error");
              return response.json();
            }
          })
          .then((data) => {
            setSuperAdmin(data.superAdmin);
            setUsers(data.data);
            setIsLoaded(true);
          })
          .catch((error) => console.log(error));
      } catch (error) {
        console.log(error);
        setIsLoaded(true);
      }
    }
    fetchContactData();
  }, [trigger, navigate]);

  const enableHandler = (id) => {
    setLoadingId(id);
    const obj = JSON.stringify({
      user_id: id,
    });
    fetch(`${process.env.REACT_APP_SERVER_URL}/enable_user`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: obj,
    }).then(() => {
      setTrigger(!trigger);
      setLoadingId(null);
    });
  };

  const disableHandler = (id) => {
    setLoadingId(id);
    const obj = JSON.stringify({
      user_id: id,
    });
    fetch(`${process.env.REACT_APP_SERVER_URL}/disable_user`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: obj,
    }).then(() => {
      setTrigger(!trigger);
      setLoadingId(null);
    });
  };

  const inviteUserOpenHandler = () => {
    setShowInviteDialog(true);
  };

  const inviteUserCloseHandler = () => {
    setShowInviteDialog(false);
  };

  const editInviteUserOpenHandler = (obj) => {
    setEditInfo({
      email: obj.email,
      role: obj.role,
      option: obj.option,
    });
    setShowEditInviteDialog(true);
  };
  const editInviteUserCloseHandler = () => {
    setShowEditInviteDialog(false);
  };

  //REMOVE INVITE HANDLERS
  const removeHandlerClicked = (obj) => {
    setShowRemoveDialog(true);
    setRemoveInfo({
      email: obj.email,
      tag: obj.tag,
    });
  };
  const handleRemoveInvite = async (email, tag) => {
    setPostLoader(true);
    const obj = JSON.stringify({
      email: email,
      tag: tag,
    });
    fetch(`${process.env.REACT_APP_SERVER_URL}/remove_workspace_invite`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "include",
      method: "POST",
      body: obj,
    }).then(() => {
      setPostLoader(false);
      setShowRemoveDialog(false);
      setTrigger(!trigger);
    });
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        {!isLoaded && (
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </Box>
        )}
        {isLoaded && (
          <>
            <div style={{ minHeight: "100px" }}>
              <div className={styles.userListContainer}>
                <ul className={styles.userList}>
                  {users.length &&
                    users.map((data) => (
                      <li className={styles.userListItem} key={data.email}>
                        <div className={styles.userInfo}>
                          <div className={styles.userEmail}>{data.email}</div>
                          <div className={styles.userRole}>{data.role}</div>
                          {data.status &&
                            (data.status === "pending" ||
                              data.status === "rejected") && (
                              <div className={styles.pending}>
                                {data.status}
                              </div>
                            )}
                          {data.status &&
                            data.status !== "pending" &&
                            data.status !== "rejected" && (
                              <div className={styles.userRegion}>
                                {data["createdAt"] !==
                                "0000-00-00T00:00:00.000Z"
                                  ? data["createdAt"]
                                      .split("T")[0]
                                      .split("-")
                                      .reverse()
                                      .join("-")
                                  : "-"}
                              </div>
                            )}
                        </div>
                        {data.email !== superAdmin &&
                          data.status === "active" && (
                            <button
                              disabled={loadingId === data.id}
                              className={styles.disableButton}
                              onClick={() => {
                                disableHandler(data.id);
                              }}
                            >
                              {loadingId === data.id ? (
                                <CircularProgress size={20} />
                              ) : (
                                "Disable"
                              )}
                            </button>
                          )}

                        {data.email !== superAdmin &&
                          data.status === "inactive" && (
                            <button
                              disabled={loadingId === data.id}
                              className={styles.enableButton}
                              onClick={() => {
                                enableHandler(data.id);
                              }}
                            >
                              {loadingId === data.id ? (
                                <CircularProgress size={20} />
                              ) : (
                                "Enable"
                              )}
                            </button>
                          )}

                        {data.email !== superAdmin &&
                          data.status !== "pending" &&
                          data.status !== "rejected" && (
                            <button
                              onClick={() => {
                                editInviteUserOpenHandler({
                                  email: data.email,
                                  role: data.role,
                                  option: data.option,
                                });
                              }}
                              className={styles.editButton}
                            >
                              Edit
                            </button>
                          )}

                        {data.email !== superAdmin && (
                          <button
                            className={styles.removeButton}
                            onClick={() => {
                              removeHandlerClicked({
                                email: data.email,
                                tag:
                                  data.status === "pending"
                                    ? "pending"
                                    : "existing",
                              });
                            }}
                          >
                            Remove
                          </button>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
              <div className={styles.bottomButtons}>
                <button onClick={inviteUserOpenHandler}>Invite User</button>
              </div>
            </div>
            <InviteDialog
              showInviteDialog={showInviteDialog}
              setShowInviteDialog={setShowInviteDialog}
              inviteUserOpenHandler={inviteUserOpenHandler}
              inviteUserCloseHandler={inviteUserCloseHandler}
              trigger={trigger}
              setTrigger={setTrigger}
            />
            {showEditInviteDialog && (
              <EditInviteDialog
                editInviteUserCloseHandler={editInviteUserCloseHandler}
                editInfo={editInfo}
                trigger={trigger}
                setTrigger={setTrigger}
                showEditInviteDialog={showEditInviteDialog}
                setShowEditInviteDialog={setShowEditInviteDialog}
              />
            )}
            <DynamicDialog
              isOpen={showRemoveDialog}
              onClose={() => setShowRemoveDialog(false)}
              title="Are you sure you want to Remove Invite User?"
              title2=""
              description={[]}
              Loader={postLoader}
              fields={[]}
              buttons={[
                {
                  label: "Cancel",
                  onClick: () => setShowRemoveDialog(false),
                },
                {
                  label: "Delete",
                  onClick: () => {
                    handleRemoveInvite(removeInfo.email, removeInfo.tag);
                  },
                },
              ]}
            />
          </>
        )}
      </div>
    </>
  );
};

export default Invite;
